import React, { useState, useEffect } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Card,
  CardContent,
  Typography,
  Divider,
  TableSortLabel,
  TextField,
  useTheme,
  Grid,
  MenuItem,
  Button,
} from "@mui/material";
import Icons from "../../Utils/Icons";
import { GET } from "../Generic/CrudRequest";
import { searchPermissions } from "../Users/PermissionsUser/PermissionsActions";
import useExcelExport from "../../Utils/useExcelExport";
import { SaveAlt } from "@mui/icons-material";
import { useTranslation } from 'react-i18next';

const columns = [
  { id: "descripcion", label: "Nombre", minWidth: "100px" },
  { id: "marca", label: "Marca", minWidth: "100px" },
];

export default function ModelUnit(props) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [rows, setRows] = React.useState([]);
  const [orderBy, setOrderBy] = React.useState("");
  const [column, setColumn] = React.useState(0);
  const [order, setOrder] = React.useState("asc");
  const [totalRecords, setTotalRecords] = React.useState(0);
  const [searchText, setSearchText] = useState("");
  const [estatus, setEstatus] = React.useState(true);
  const [register, setRegister] = useState(false);
  const [edit, setEdit] = useState(false);
  const theme = useTheme();
  const { config } = props;
  const exportToExcel = useExcelExport();
  const { t } = useTranslation();

  const handleExport = () => {
    exportToExcel(rows, columns, t("modelUnit.titleExcel"));
  };
  useEffect(() => {
    fetchClients();
  }, [page, rowsPerPage, column, order]);

  const fetchClients = async () => {
    const dataModelUnits = await GET(`${config.url}/api/ModelUnit/paginado`, {
      start: page * rowsPerPage,
      length: rowsPerPage,
      busqueda: searchText,
      estatus: estatus,
      column: column,
      dir: order,
    });

    setRows(dataModelUnits.resultado);
    setTotalRecords(dataModelUnits.totalRegistros);

    const permissionsArray = JSON.parse(localStorage.getItem("permissions"));

    const permissionRegister = searchPermissions(
      "Unidades",
      "Registrar",
      permissionsArray
    );

    const permissionEdit = searchPermissions(
      "Unidades",
      "Editar",
      permissionsArray
    );

    setRegister(permissionRegister);
    setEdit(permissionEdit);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleRequestSort = (property, columnNumber) => {
    const isAsc = orderBy === property && order === "asc";
    setColumn(columnNumber);
    setOrderBy(property);
    setOrder(isAsc ? "desc" : "asc");
  };

  const handleSearch = () => {
    fetchClients();
  };

  const handleClear = () => {
    setSearchText("");
    setEstatus(true);
  };

  const handleChangeEstatus = (event) => {
    setEstatus(event.target.value);
  };

  const columns = [
    { id: "descripcion", label: t('modelUnit.name'), minWidth: "100px" },
    { id: "marca", label: t('modelUnit.brand'), minWidth: "100px" },
  ];

  return (
    <Card
      variant="outlined"
      sx={{
        overflow: "hidden",
        boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
        border: "1px solid rgba(0, 0, 0, 0.1)",
        borderRadius: 2,
      }}
    >
      <CardContent>
        <CardContent
          sx={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            justifyContent: "space-between",
            overflow: "hidden",
            maxWidth: "100%",
          }}
        >
          <Typography variant="h3" sx={{ flex: "1", fontWeight: "bold" }}>
            {t('modelUnit.title')}
          </Typography>
          {register && (
            <Icons
              iconName="Add"
              fontSize="large"
              to="/ModelosUnidad/Agregar"
              style={{
                marginLeft: "auto",
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.white.main,
              }}
              tooltip={t('buttons.add')}
            />
          )}
        </CardContent>
        <Divider sx={{ maxWidth: "calc(100% - 32px)", margin: "auto" }} />
        <CardContent
          sx={{
            maxWidth: "calc(100% - 32px)",
            margin: "auto",
            alignItems: "auto",
          }}
        >
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={3}>
              <TextField
                label={t('modelUnit.name')}
                type="search"
                InputLabelProps={{
                  shrink: true,
                }}
                variant="standard"
                size="small"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                sx={{
                  width: 400,
                  maxWidth: "100%",
                  color: theme.palette.primary.main,
                }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                select
                label={t('filters.status')}
                InputLabelProps={{
                  shrink: true,
                }}
                name="estatus"
                variant="standard"
                size="small"
                value={estatus}
                fullWidth
                onChange={handleChangeEstatus}
              >
                <MenuItem value={true}>{t('units.active')}</MenuItem>
                <MenuItem value={false}>{t('units.inactive')}</MenuItem>
              </TextField>
            </Grid>
            <Icons
              iconName="Search"
              fontSize="large"
              onClick={handleSearch}
              style={{ color: theme.palette.primary.main }}
              tooltip={t('buttons.search')}
            />
            <Icons
              iconName="Clear"
              fontSize="large"
              onClick={handleClear}
              style={{ color: theme.palette.primary.main }}
              tooltip={t('buttons.clear')}
            />
          </Grid>
        </CardContent>
        <Paper
          sx={{
            maxWidth: "calc(100% - 32px)",
            margin: "auto",
            overflow: "hidden",
            boxShadow: "none",
            border: "none",
          }}
        >
          <TableContainer>
            <Button
              variant="contained"
              startIcon={<SaveAlt />}
              onClick={handleExport}
            >
              {t('buttons.exportExcel')}
            </Button>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align="left"
                      style={{ minWidth: column.minWidth, fontWeight: "bold" }}
                    >
                      <TableSortLabel
                        active={orderBy === column.id}
                        direction={orderBy === column.id ? order : "asc"}
                        onClick={() =>
                          handleRequestSort(column.id, columns.indexOf(column))
                        }
                      >
                        {column.label}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={columns.length + 1} align="center">
                      {t('modelUnit.noModelsAvailable')}
                    </TableCell>
                  </TableRow>
                )}
                {rows.map((row, index) => {
                  return (
                    <TableRow key={index}>
                      {columns.map((column) => (
                        <TableCell key={column.id} align="left">
                          {row[column.id] !== null && row[column.id] !== "" ? (
                            row[column.id]
                          ) : (
                            <i>{t('pagination.notAvailable')}</i>
                          )}
                        </TableCell>
                      ))}
                      <TableCell align="right">
                        {edit && (
                          <Icons
                            iconName="Edit"
                            fontSize="medium"
                            style={{
                              backgroundColor: theme.palette.primary.main,
                              color: "#fff",
                            }}
                            to={`/ModelosUnidad/Editar/${row.idUnidadModelo}`}
                            tooltip={t('buttons.edit')}
                          />
                        )}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100, { value: -1, label: t('pagination.all') }]}
            component="div"
            count={totalRecords}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage={t('pagination.labelRowsPerPage')}
            labelDisplayedRows={({ from, to, count }) =>
              t('pagination.displayedRows', { from, to, count })
            }
          />
        </Paper>
      </CardContent>
    </Card>
  );
}
